<template>
  <div class="">
    <div class="d-flex flex-md-column flex-row flex-xl-row justify-content-start align-items-md-center">
      <div class="">
        <highcharts :options="options" />
      </div>
      <div class="d-flex justify-content-center flex-column">
        <status-column :title="label" :value="percent + '%'" :value-font-size-class="'font_size_1000rem'"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue';
import StatusColumn from "@/components/dashboard/StatusColumn";

export default {
  name: 'PercentageDonut',
  components: {
    highcharts: Chart,
    StatusColumn,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    percent: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    const percentValue = this.percent === 0 ? null : this.percent;
    const options = {
      chart: {
        type: 'pie',
        plotShadow: false,
        backgroundColor: 'transparent',
        height: '75px',
        width: 75,
        spacing: [7, 7, 7, 7],

        plotBorderWidth: 0,
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          center: [15, '50%'],
          innerSize: '100%',
          startAngle: 135,
          borderWidth: 8,
          borderColor: null,
          dataLabels: {
            connectorWidth: 0,
          },
        },
        series: {
          stacking: 'normal',
          enableMouseTracking: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      },
      title: {
        verticalAlign: 'middle',
        floating: true,
        text: '',
      },
      legend: {},
      series: [
        {
          id: 'idCompletion',
          name: '',
          data: [
            {
              name: 'Completed',
              y: percentValue,
              color: '#00586F',
              dataLabels: { enabled: false },
            },
            {
              name: 'Uncompleted',
              y: 100 - percentValue,
              color: '#333333',
              dataLabels: { enabled: false },
              opacity: 0.1,
            },
          ],
        },
      ],
      tooltip: {
        enabled: false,
      },
    };

    return {
      options,
    };
  },
  watch: {
    percent: function (newPercent) {
      const percentValue = newPercent === 0 ? null : newPercent;
      this.options.series[0].data = [
        {
          name: 'Completed',
          y: percentValue,
          color: '#00586F',
          dataLabels: { enabled: false },
        },
        {
          name: 'Uncompleted',
          y: 100 - percentValue,
          color: '#333333',
          dataLabels: { enabled: false },
          opacity: 0.1,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
